import _classCallCheck from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module ui/colorgrid/colortileview
 */
import ButtonView from '../button/buttonview.js';
import checkIcon from '../../theme/icons/color-tile-check.svg';
/**
 * This class represents a single color tile in the {@link module:ui/colorgrid/colorgridview~ColorGridView}.
 */
var ColorTileView = /*#__PURE__*/function (_ButtonView) {
  _inherits(ColorTileView, _ButtonView);
  var _super = _createSuper(ColorTileView);
  function ColorTileView(locale) {
    var _this;
    _classCallCheck(this, ColorTileView);
    _this = _super.call(this, locale);
    var bind = _this.bindTemplate;
    _this.set('color', undefined);
    _this.set('hasBorder', false);
    _this.icon = checkIcon;
    _this.extendTemplate({
      attributes: {
        style: {
          backgroundColor: bind.to('color')
        },
        class: ['ck', 'ck-color-grid__tile', bind.if('hasBorder', 'ck-color-selector__color-tile_bordered')]
      }
    });
    return _this;
  }
  /**
   * @inheritDoc
   */
  _createClass(ColorTileView, [{
    key: "render",
    value: function render() {
      _get(_getPrototypeOf(ColorTileView.prototype), "render", this).call(this);
      this.iconView.fillColor = 'hsl(0, 0%, 100%)';
    }
  }]);
  return ColorTileView;
}(ButtonView);
export { ColorTileView as default };